import { SelectedOrgChecker } from '@features/organisations/components/SelectedOrgChecker'
import { ScheduledAutomationsList } from '@features/automations/components/ScheduledAutomationsList'
import { createFileRoute } from '@tanstack/react-router'
import { zodValidator } from '@tanstack/zod-adapter'
import {
  AUTOMATION_ORDER_BY_FIELDS,
  DEFAULT_SCHEDULED_AUTOMATION_ORDER,
  listAutomationsRequestSchema,
} from '@customTypes/cloudmix/automations'
import { withListHydration } from '@lib/listState/withListHydration'

const ScheduledAutomationsRoute = () => (
  <SelectedOrgChecker>
    <ScheduledAutomationsList />
  </SelectedOrgChecker>
)

const routerSchema = listAutomationsRequestSchema.partial().catch({})
const routeId = '/_auth/o/$orgId/automations/scheduled' as const

export const Route = createFileRoute(routeId)({
  component: ScheduledAutomationsRoute,
  validateSearch: zodValidator(routerSchema),
  beforeLoad: withListHydration({
    list: {
      routeId,
      defaultSort: [DEFAULT_SCHEDULED_AUTOMATION_ORDER],
      allowedOrderByFields: AUTOMATION_ORDER_BY_FIELDS,
    },
    getTitle: () => 'Scheduled Automations',
  }),
  loader: () => ({
    crumb: 'Scheduled',
  }),
})
